import React from "react";
import { toast } from "react-toastify";
import { Button } from "src/Components";
import TextInput from "src/Components/TextInput";
import { ICustomerReportScopeChangePasswordFormValues } from "src/Interfaces/reportLinks";
import { changeCustomerReportScopePassword } from "src/Requests/reportLinksRequests";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  id: number;
  onClose: () => void;
  onSuccess: () => void;
}

const ChangePasswordModal: React.FC<IProps> = ({ id, onClose, onSuccess }) => {
  const [loading, setLoading] = React.useState(false);
  const [formValues, setFormValues] =
    React.useState<ICustomerReportScopeChangePasswordFormValues>({
      id,
      newPassword: "",
      confirmNewPassword: "",
    });

  const changeHandler = (name: string, value: any) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const preventAutofillOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.readOnly = false;
  };

  const isDisabled = () => {
    if (!formValues.newPassword || !formValues.confirmNewPassword) return true;
    if (formValues.newPassword !== formValues.confirmNewPassword) return true;
    return false;
  };

  const submitHandler = () => {
    setLoading(true);
    changeCustomerReportScopePassword(formValues)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onSuccess();
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };
  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full">
      <TextInput
        label="رمز عبور جدید"
        name="newPassword"
        type="password"
        value={formValues.newPassword}
        onChange={changeHandler}
        autoComplete="new-password"
        readOnly
        onFocus={preventAutofillOnFocus}
      />
      <TextInput
        label="تکرار رمز عبور جدید"
        name="confirmNewPassword"
        type="password"
        value={formValues.confirmNewPassword}
        onChange={changeHandler}
        autoComplete="new-password"
        readOnly
        onFocus={preventAutofillOnFocus}
      />
      <div className="w-full self-center mt-4">
        <Button
          text="ثبت"
          onClick={submitHandler}
          variant="contained"
          loading={loading}
          disabled={isDisabled()}
        />
      </div>
    </div>
  );
};

export default ChangePasswordModal;
